import { useEffect, useState } from 'react'
import { toast } from 'sonner'
import { platformService } from '@/services/platformService'

const EMPTY = { name: '', rut: '', industry: '', website: '', tenantSlug: '' }

export default function AccountsPage() {
    const [accounts, setAccounts] = useState<any[]>([])
    const [loading, setLoading] = useState(true)
    const [showModal, setShowModal] = useState(false)
    const [form, setForm] = useState(EMPTY)

    const reload = () => {
        setLoading(true)
        platformService.crmAccounts().then(setAccounts).catch(() => toast.error('No se pudieron cargar las cuentas')).finally(() => setLoading(false))
    }
    useEffect(reload, [])

    const create = async (e: React.FormEvent) => {
        e.preventDefault()
        try { await platformService.crmCreateAccount(form); toast.success('Cuenta creada'); setShowModal(false); setForm(EMPTY); reload() }
        catch { toast.error('No se pudo crear') }
    }
    const remove = async (a: any) => {
        if (!window.confirm(`¿Eliminar cuenta "${a.name}"?`)) return
        try { await platformService.crmDeleteAccount(a.id); reload() } catch { toast.error('No se pudo eliminar') }
    }

    return (
        <div>
            <div className="mb-6 flex items-center justify-between">
                <h1 className="text-2xl font-semibold">Cuentas</h1>
                <button onClick={() => setShowModal(true)} className="rounded-md bg-indigo-600 px-4 py-2 text-sm font-medium text-white hover:bg-indigo-500">+ Nueva cuenta</button>
            </div>

            <div className="overflow-hidden rounded-xl border border-slate-800">
                <table className="w-full text-left text-sm">
                    <thead className="bg-slate-800/70 text-slate-300"><tr>
                        <th className="px-4 py-3">Nombre</th><th className="px-4 py-3">RUT</th><th className="px-4 py-3">Industria</th>
                        <th className="px-4 py-3">Web</th><th className="px-4 py-3">Tenant</th><th className="px-4 py-3"></th>
                    </tr></thead>
                    <tbody className="divide-y divide-slate-800">
                        {loading && accounts.length === 0 ? (
                            <tr><td colSpan={6} className="px-4 py-6 text-center text-slate-400">Cargando…</td></tr>
                        ) : accounts.length === 0 ? (
                            <tr><td colSpan={6} className="px-4 py-6 text-center text-slate-400">Sin cuentas</td></tr>
                        ) : accounts.map((a) => (
                            <tr key={a.id} className="text-slate-200">
                                <td className="px-4 py-2">{a.name}</td>
                                <td className="px-4 py-2 text-slate-400">{a.rut || '—'}</td>
                                <td className="px-4 py-2 text-slate-400">{a.industry || '—'}</td>
                                <td className="px-4 py-2 text-slate-400">{a.website || '—'}</td>
                                <td className="px-4 py-2 font-mono text-xs text-slate-400">{a.tenantSlug || '—'}</td>
                                <td className="px-4 py-2 text-right"><button onClick={() => remove(a)} className="text-xs text-rose-400 hover:underline">eliminar</button></td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

            {showModal && (
                <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 px-4">
                    <form onSubmit={create} className="w-full max-w-md space-y-3 rounded-xl border border-slate-700 bg-slate-800 p-6">
                        <h2 className="text-lg font-semibold text-slate-100">Nueva cuenta</h2>
                        {([['name', 'Nombre / empresa', true], ['rut', 'RUT', false], ['industry', 'Industria', false], ['website', 'Sitio web', false], ['tenantSlug', 'Slug del tenant (si ya es cliente)', false]] as const).map(([k, label, req]) => (
                            <input key={k} value={(form as any)[k]} onChange={(e) => setForm({ ...form, [k]: e.target.value })} placeholder={label} required={req}
                                className="w-full rounded-md border border-slate-600 bg-slate-900 px-3 py-2 text-sm text-slate-100 outline-none focus:border-indigo-500" />
                        ))}
                        <div className="flex justify-end gap-2 pt-2">
                            <button type="button" onClick={() => setShowModal(false)} className="rounded-md border border-slate-600 px-4 py-2 text-sm text-slate-300 hover:bg-slate-700">Cancelar</button>
                            <button type="submit" className="rounded-md bg-indigo-600 px-4 py-2 text-sm font-medium text-white hover:bg-indigo-500">Crear</button>
                        </div>
                    </form>
                </div>
            )}
        </div>
    )
}
